import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../views/firebaseConfig';
import { useAuth } from '../contexts/AuthContext';
import AuthDialog from './AuthDialog';
import searchAsset from '../assets/android/ui/p4r_feed_search.svg';
import messagesAsset from '../assets/android/ui/p4r_inbox_all.svg';
import settingsAsset from '../assets/android/ui/p4r_concept_profile.svg';
import './AppToolbar.css';

export default function AppToolbar({ onNavigate, onSearchToggle, searchOpen, onOpenMessages }) {
  const { user, loading: authLoading } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [hasCompleteProfile, setHasCompleteProfile] = useState(false);
  const location = useLocation();
  const onFeed = location.pathname === '/feed' || location.pathname === '/';
  const onMap = location.pathname === '/map';
  const onPlayers = location.pathname === '/players';

  useEffect(() => {
    if (authLoading || !user) {
      setHasCompleteProfile(false);
      return undefined;
    }
    return onSnapshot(doc(firestore, 'userprofiles', user.uid), (snap) => {
      const data = snap.exists() ? snap.data() : {};
      setHasCompleteProfile(Boolean(data.nickname && data.bio && data.profileImageUrl));
    }, () => setHasCompleteProfile(false));
  }, [authLoading, user]);

  if (searchOpen || onFeed) return null;

  const requireAuth = (action) => {
    if (!user) {
      setShowLogin(true);
      return;
    }
    action?.();
  };

  return (
    <>
      <div className="p4r-screen-actions" aria-label="Screen actions">
        {(onMap || onPlayers) && onSearchToggle && (
          <button type="button" className="p4r-screen-action" onClick={() => onSearchToggle(true)} title="Search">
            <img src={searchAsset} alt="" />
          </button>
        )}
        {user && onOpenMessages && (
          <button type="button" className="p4r-screen-action" onClick={onOpenMessages} title="Messages">
            <img src={messagesAsset} alt="" />
          </button>
        )}
        <button
          type="button"
          className="p4r-screen-action"
          onClick={() => requireAuth(() => onNavigate?.('settings'))}
          title={hasCompleteProfile ? 'Edit profile' : 'Complete profile'}
        >
          <img src={settingsAsset} alt="" />
          {user && !hasCompleteProfile && <span className="p4r-screen-action-dot" />}
        </button>
      </div>
      <AuthDialog show={showLogin} onClose={() => setShowLogin(false)} />
    </>
  );
}
